<template>
  <QCard
    :class="[
      'overflow-hidden',
      {
        'full-width': $q.screen.lt.md,
        'full-height': $q.screen.lt.md
      }
    ]"
  >
    <div :class="['row', { 'fixed-card': $q.screen.gt.sm }]">
      <div class="col-xs-12 col-md-6">
        <PageHeader class="q-pb-md q-px-lg q-mx-md q-pt-lg q-mt-md">
          <h4>Let’s Get Started!</h4>
        </PageHeader>
        <QForm @submit="$emit('signUp')" class="q-px-lg q-mx-md">
          <SAIFormError
            v-if="errors.$error && errors.$dirty"
            class="q-mt-md q-mb-sm"
          />
          <div class="column">
            <SAIEmailInput
              :value="email"
              large
              placeholder="Email Address"
              :disable="disable"
              :error="errors.email.$error"
              @input="$emit('update:email', $event)"
            />
            <NameInput
              :value="firstName"
              :error="errors.firstName.$error"
              placeholder="First Name"
              :disable="disable"
              @input="$emit('update:firstName', $event)"
            />
            <NameInput
              :value="lastName"
              :error="errors.lastName.$error"
              placeholder="Last Name"
              :disable="disable"
              @input="$emit('update:lastName', $event)"
            />
            <SAIPasswordInput
              :value="password"
              class="q-mt-sm"
              large
              placeholder="Password"
              :error="errors.password.$error"
              :disable="disable"
              :show-password="showPassword"
              @input="$emit('update:password', $event)"
              @update:showPassword="$emit('update:showPassword', $event)"
            />
            <p class="q-px-sm q-mt-md text-center text-body3 text-grey-6">
              Password must contain at least 8 characters with at least 1
              number, 1 upper case, and 1 symbol.
            </p>
            <p class="q-px-sm q-mt-lg text-center text-body2">
              By signing up, I agree to the
              <SAILink
                class="text-weight-bold"
                :href="termsLink"
                target="_blank"
                label="Terms of Use"
              />
              and
              <SAILink
                class="text-weight-bold"
                :href="privacyPolicyLink"
                target="_blank"
                label="Privacy Policy"
              />
            </p>
            <div class="row justify-center q-py-lg">
              <SAIBtn
                padding="11px 48px"
                size="16px"
                label="Sign Up"
                :no-caps="true"
                type="submit"
                :disable="disable"
                :loading="loading"
              />
            </div>
          </div>
        </QForm>
        <SignUpCardAction @click="$emit('logIn')">
          <span class="q-pa-xs text-grey-10">Already have an account?</span>
          <span class="text-primary">Log in</span>
        </SignUpCardAction>
      </div>
      <div class="q-pa-lg bg-primary-gradient col-xs-12 col-md-6">
        <div class="q-pa-md row row items-center full-height">
          <QImg :src="image" alt="Sign Up" basic />
        </div>
      </div>
    </div>
  </QCard>
</template>

<script>
import { QForm, QCard, QImg } from 'quasar';
import {
  SAIBtn,
  SAIEmailInput,
  SAIPasswordInput,
  SAIFormError,
  getAsset,
  SAILink
} from 'ecx.saigon.ui.common';

export default {
  name: 'SignUp',
  props: {
    email: String,
    firstName: String,
    lastName: String,
    password: String,
    loading: Boolean,
    disable: Boolean,
    showPassword: Boolean,
    termsLink: String,
    privacyPolicyLink: String,
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      image: undefined
    };
  },
  async mounted() {
    this.image = await getAsset(this.$Constants.GIRL_ON_CAR_PATH);
  },
  components: {
    QImg,
    QCard,
    QForm,
    SAIBtn,
    SAIEmailInput,
    SAIPasswordInput,
    SAIFormError,
    SAILink,
    SignUpCardAction: () => import('../../atom/sign-up-card-action'),
    PageHeader: () => import('../../atom/page-header'),
    NameInput: () => import('../../atom/name-input')
  }
};
</script>

<style lang="sass" scoped>
.fixed-card
  width: 840px
</style>
